module.exports = __webpack_public_path__ + "img/ApprTemp5.6c491e4c.png";